import { createContext, useContext, useEffect, useState } from 'react';

// CONTEXT
import { AuthContext } from './AuthContext';
import { useSeasonTheme } from './SeasonThemeContext';

// SERVICES
import { getUserBDDInfo, updateUser } from 'services/userService';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');
  const { email } = useContext(AuthContext);
  const { seasonTheme } = useSeasonTheme();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await getUserBDDInfo(email);
      setUser(user.data[0]);
    };
    fetchUser();
  }, [email]);

  useEffect(() => { 
    if (user) { 
      // Si Halloween est actif, forcer le mode sombre
      if (seasonTheme === 'halloween') {
        setTheme('dark');
        document.documentElement.classList.add('dark');
      } else {
        // Sinon, utiliser les préférences utilisateur
        if (user.USR_DARK_MODE) {
          setTheme('dark');
          document.documentElement.classList.add('dark');
        } else {
          setTheme('light');
          document.documentElement.classList.remove('dark');
        }
      }
    }
  }, [user, seasonTheme]);

  const changeTheme = (newTheme) => {
    // Ne pas permettre de changer le thème si Halloween est actif
    if (seasonTheme === 'halloween') {
      return; // Halloween force le mode sombre
    }
    
    setTheme(newTheme);
    if (newTheme === 'light') {
      updateUser(email, { dark_mode: 0 });
      document.documentElement.classList.remove('dark');
    } else {
      updateUser(email, { dark_mode: 1 });
      document.documentElement.classList.add('dark');
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}